
import { useAuthContext } from "../hooks/useAuthContext"
import { useLogout } from '../hooks/useLogout'
import styles from './Navbar.module.css'
import uobLogo from '../../src/media/uob.png'
import { Badge, Button, Card, Col, Container, Image, Modal, ModalHeader, Nav, Row } from "react-bootstrap"
import { includesNumber } from "../utils/includeNumber"
import { ImExit } from 'react-icons/im';
import { MdAdd, MdDashboard} from "react-icons/md"
import {  useMediaQuery } from '@material-ui/core';
import { useEffect, useState } from "react"
import StatModal from "./StatModal"
import StatisticsModal from "./StatModal"
import RegisterStudents from "./RegisterStudents"

export default function Navbar() {
  const { logout } = useLogout();
  const { user } = useAuthContext();
  const [openStats, setOpenStats] = useState(false)
  const isSmallScreen = useMediaQuery('(max-width: 600px)');
  const [openRegister, setOpenRegister] = useState(false)
  let [firstWord, secondWord] =  (user) ? user.email?.match(/^(.*?)@/)?.[1].split(".") : '';

  return (
    <>
    <Nav className={styles['navbar-responsive']}  dir="rtl"
    activeKey="/home"
    onSelect={(selectedKey) => alert(`selected ${selectedKey}`)}
  >
  
    <Nav.Item >
      <div>
    <Image className={styles['university-logo']} fluid={true} src={uobLogo} alt="University of Benghazi Logo" />
      </div>
    </Nav.Item>
 
    <Nav.Item style={{display:'grid', alignItems: 'center',  marginLeft:' 30px'}}>
      <div className="d-flex " style={{gap: '12px', marginTop: '0.5rem'}}> 
   <h6 style={{marginTop: '0.5rem'}}> مرحبا , { includesNumber(user?.email) ? user?.email.match(/^(.*?)@/)?.[1] :  firstWord + " " +  secondWord } </h6> 
            
    {isSmallScreen ? (
      <ImExit style={{marginTop: '10px'}}  onClick={logout} />
    ) : (
      <Button className="d-none d-sm-inline" style={{width: "9.5rem"}} variant="dark" onClick={logout}> 
       تسجيل خروج 
      </Button>
    )}
   { user?.email === 'zainab.mones@uob.edu.ly' ?  (isSmallScreen ?    <MdDashboard style={{marginTop: '10px'}}    onClick={() => setOpenStats(true)}/>  : <Button onClick={() => setOpenStats(true)} variant="primary"> احصائيات </Button>  )  : '' }
   { user?.email === 'zainab.mones@uob.edu.ly' ?  (isSmallScreen ?    <MdAdd style={{marginTop: '10px'}}    onClick={() => setOpenRegister(true)}/>  : <Button onClick={() => setOpenRegister(true)} variant="primary"> تسجيل الطلبة </Button>  )  : ''   }
 
   </div>
    </Nav.Item>

  </Nav>
 <StatModal openStats={openStats} setOpenStats={setOpenStats} />
 <RegisterStudents openRegister={openRegister} setOpenRegister={setOpenRegister}  />
 
  </>
  );
}
